import apiUrlAddresses from 'config/constants/api-urls-addresses'
import { Http } from 'lib'
import { Dispatch } from 'react'
import { get } from 'lodash'
import { getUserProfile, PublicProfileAction } from './store/Actions'
import { IGetWordBanksPayload, IGetWordBanksResponse, WordBankCategory } from 'types'
import apiUrlsAddresses from '../../config/constants/api-urls-addresses'

export default class PublicProfileService {
  static onMount(userId: string, enterpriseId: string, dispatch: Dispatch<PublicProfileAction>) {
    return async () => {
      let userProfileResponse: any = {}
      let wordBankResponse: any = {}
      let initiativesResponse: any = {}
      try {
        const result = await Promise.all([
          this.getUserProfile(userId),
          this.getAllWordBanks(userId),
          this.getUserInitiatives(userId, enterpriseId)
        ])
        wordBankResponse = result.pop()
        userProfileResponse = result.pop()
        initiativesResponse = result.pop()
      } catch (error) {
        dispatch(getUserProfile({ ...error }))
        return
      }
      dispatch(getUserProfile({ ...userProfileResponse, ...wordBankResponse, ...initiativesResponse }))
    }
  }

  static async getUserProfile(userId: string) {
    const [data, status, error] = await Http.get<string>(apiUrlAddresses.billboard.json(userId))
    if (error) {
      if (status === 404) {
        throw { error: 'Profile not found!' }
      } else {
        throw error
      }
    }
    const { user } = get(data, 'data', null)
    const { responses, validation, questions } = get(data, 'data.userResponses', null)
    return { user, responses, validation, questions }
  }

  static async getWordBanks({
    category,
    userId
  }: IGetWordBanksPayload): Promise<[IGetWordBanksResponse | null, number, string | null]> {
    return Http.get<IGetWordBanksResponse>(apiUrlsAddresses.wordBanks.get({ category, userId }))
  }

  static async getAllWordBanks(userId: string) {
    const categories = [WordBankCategory.CompanyDescriptor, WordBankCategory.Xfactor, WordBankCategory.TalentTags]
    const wordBanks = {}

    await Promise.all(
      categories.map(async (category: any) => {
        const [response, , error] = await this.getWordBanks({ category, userId })
        if (Boolean(error)) {
          throw error
        }
        wordBanks[category] = response.data
      })
    )

    return { wordBanks }
  }

  static async getUserInitiatives(userId: string, enterpriseId: string) {
    if (!enterpriseId) {
      return {}
    }
    const [data, status, error] = await Http.get<string>(apiUrlAddresses.me.initiatives(userId))
    if (error) {
      if (status === 404) {
        throw { error: 'Profile not found!' }
      } else {
        throw error
      }
    }
    const result: any[] = get(data, 'initiatives', [])
    const enterprise = result.find(i => i.enterpriseId === enterpriseId)
    const initiatives = (enterprise?.initiatives || []).map((initiative: any) => ({
      description: initiative.title,
      answers: initiative.questions.map((question: any) => ({
        currentText: question.text,
        talentAnswer:
          question.answer ||
          question.options
            .filter((option: { id: number }) => question.choices.includes(option.id))
            .map((choice: { text: string }) => choice.text)
      }))
    }))
    return { initiatives }
  }
}
